var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoNoVendors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 20a4 4 0 0 1 4 4v36a4 4 0 0 1-4 4h-56a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v16h28zm-30 24h-28v16a2 2 0 0 0 1.85 1.995L4.5 62h26V44zm16-22h-14v40h14V22zm14 0h-12v40h12a2 2 0 0 0 1.995-1.85L62.5 60V24a2 2 0 0 0-1.85-1.995L60.5 22zm-30 0h-28v20h28V22zm-2-20h-24a2 2 0 0 0-1.995 1.85L2.5 4v16h28V4a2 2 0 0 0-1.85-1.995L28.5 2z",
    fill: "#B2B8CF",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNoVendors);
export default __webpack_public_path__ + "static/media/ico-no-vendors.e2c224607900f1da5aa7d06b46beb90d.svg";
export { ForwardRef as ReactComponent };